import React from 'react';
import {View} from 'MWC';
import {Link} from 'MWC';

class SmallBanner extends View {
    constructor(props) {
        super(props);
    }

    render() {
        const {href, navigate, closeMenuHandler, img, title, text} = this.props;

        return (
            <Link
                href={href}
                onClick={e => {
                    navigate(href, e);
                    if (closeMenuHandler) {
                        closeMenuHandler();
                    }
                }}
                className='header-menu-banner-small'
            >
                <div className='left-side'>
                    <div style={{width: 120, height: 80}}>
                        <img
                            src={img}
                            alt={this.l10n(title)}
                            className='header-menu-banner-small-img'
                            style={{width: 120, height: 80}}
                        />
                    </div>
                </div>
                <div className='right-side'>
                    <div className='right-side-title'>{this.l10n(title)}</div>
                    <div className='right-side-subtitle'>{this.l10n(text)}</div>
                </div>
            </Link>
        );
    }
}

export default SmallBanner;
